
      (function () {
        var base = import.meta.env.BASE_URL;
        var l = window.location;
        var root = base.replace(/\/$/, '');
        if (l.pathname === base || (root && l.pathname === root)) return;
        try {
          sessionStorage.setItem('m:redirect', l.pathname + l.search + l.hash);
        } catch (e) {}
        l.replace(l.origin + base);
      })();
    